import { useMemo } from "react";

import { Box, Container, Grid } from "@mui/material";
import i18next from "i18next";

import { MainLayout } from "@shared/ui/MainLayout";
import MDBox from "@vendor/components/MDBox";
import { getUrlFile } from "@shared/utils/setting";

import { CardPage } from "../components/CardPage";
import { Cover } from "../components/Cover";
import { usePeopleCulture } from "../hooks/usePeopleCulture";

const COVER_FILE = "04_PP_Cover_Admin.png";

export const AdministrationPage = () => {
  const { data, isFetching } = usePeopleCulture();

  // Imágenes de administración más la portada.
  const imageServer = useMemo(() => {
    if (!data) return null;
    const cover = (data.imageCover ?? []).find((image) => image.fileName === COVER_FILE);
    return cover ? [...(data.imageAdministration ?? []), cover] : [...(data.imageAdministration ?? [])];
  }, [data]);

  // OJO: `linkInability` no existe en PeopleAndCultureDTO, asi que esto es siempre
  // undefined y el segundo link de la tarjeta de incapacidades nunca se renderiza. Se
  // conserva el comportamiento actual; corregirlo requiere saber de donde deberia salir
  // ese link (probablemente del mapa `links`), que es una pregunta para el backend.
  const linkInability = (data as { linkInability?: string } | undefined)?.linkInability ?? "";

  const getFile = (fileName: string) => {
    const value = imageServer?.find((image) => image.fileName === fileName);
    if (!value) return "";
    return getUrlFile(value.fileId as string, value.extension as string);
  };

  return (
    <MainLayout loading={isFetching}>
      {imageServer && (
        <Container>
          <Cover getFile={getFile} fileName={COVER_FILE} name="Administración" />
          <MDBox py={3}>
            <Grid container spacing={3}>
              <Grid size={12}>
                <Box>
                  <Grid container spacing={3}>
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                        lg: 4,
                      }}
                    >
                      <CardPage
                        title={i18next.t("unpaidLeaves")}
                        image={getFile("02_AD_out.png")}
                        content={i18next.t("unpaidLeavesMessage")}
                        textFirst={i18next.t("obtain")}
                        urlFirst="#/solicitudes/registro"
                      />
                    </Grid>
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                        lg: 4,
                      }}
                    >
                      <CardPage
                        title={i18next.t("medicalDisabilities")}
                        image={getFile("01_AD_incapacidad.png")}
                        content={i18next.t("medicalDisabilitiesMessage")}
                        textFirst={i18next.t("obtain")}
                        urlFirst="#/solicitudes/registro"
                        urlSecond={linkInability}
                      />
                    </Grid>
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                        lg: 4,
                      }}
                    >
                      <CardPage
                        title={i18next.t("laborCertificates")}
                        image={getFile("04_AD_certificados_laborales.png")}
                        content={i18next.t("laborCertificatesMessage")}
                        textFirst={i18next.t("obtain")}
                        urlFirst="#/solicitudes/registro"
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </MDBox>
        </Container>
      )}
    </MainLayout>
  );
};
